export default __webpack_public_path__ + "static/media/bg-featured-news-sample.50ef9e71.jpg";